import { render, staticRenderFns } from "./ticketdepartmentdetails.vue?vue&type=template&id=13d268fe&"
import script from "./ticketdepartmentdetails.vue?vue&type=script&lang=js&"
export * from "./ticketdepartmentdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports